<template>
    <div class="scheduleWishlistVue" v-loading="loading">
    <!-- Main Body Content area -->
        <div v-if="isEmployeeAllowed">
            <div class="o-main-content-area">
                <!-- Heading Section -->
                <div class="o-page-top-heading">
                    <div class="row c-responsive-fixwidth">
                        <div class="col-md-4">
                            <h1 class="h1">Wishlist</h1>
                            <div class="employee-summary-profile employee-summary-profile--inline">
                                <div class="employee-summary-profile-pic c-user__profile-pic">
                                    <img v-if="profileImage && profileImage != '' && profileImage != 'NULL'" :src="(profileImage)" />
                                    <img v-if="profileImage && (profileImage == '' || profileImage == 'NULL')" src="static/assets/images/user1.png" />
                                </div> 
                                <div class="summary-info o-schedule-user">
                                    <h1 class="h1">{{employee_name}}</h1> 
                                    <p v-for="(phone,index) in employeePhone" :key="index">
                                        <span>{{phone.label}}</span> {{phone.phone_number}}
                                    </p>
                                    <div v-if="employeePhone.length <= 0">
                                        <p><span>Home Phone:</span> NA</p>
                                        <p><span>Mobile Phone:</span> NA</p>
                                    </div>
                                    
                                </div>

                            </div>
                        </div>

                        <div class="col-md-8 text-right">
                            <ul class="o-filter-area">
                                <li v-if="getPower('employeeSearch')"><input type="text" v-model="search_query" class="form-control search-input-employee" placeholder="Search" name="Search"></li>

                                <!-- <li><a href="javascript: void(0)" @click="goToEmployee()" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a></li> -->
                                <li v-if="getPower('editUserProfile')"><a @click ="editEmployee()" href="javascript: void(0)" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-pencil" aria-hidden="true"></i> Edit User Profile</a></li>
                                <li><a href="javascript: void(0)" @click="viewSchedule()" class="c-common-btn c-common-btn--large c-common-btn--green"><i class="fa fa-eye"></i>Schedule</a></li>
                                <li><a href="javascript: void(0)" @click="scheduleSmslog()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-envelope-o" aria-hidden="true"></i> Notify log</a></li>
                                <li><a href="javascript: void(0)" @click="scheduleActionlog()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Action</a></li>
                            </ul>
                        </div>
                    </div>

                    <div class="row c-responsive-fixwidth mt-30">
                        <div class="col-md-4">
                            <div class="switch-para-block">
                                <div class="toggle-btn">
                                    <el-switch
                                    style="display: block"
                                    v-model="availability_status"
                                    active-color="#13ce66"
                                    inactive-color="#dcdfe6"
                                    :active-value="1"
                                    :inactive-value="0"
                                    @change="changeAvailabilityStatus"                                            
                                    >
                                    </el-switch>
                                </div>
                                <div class="content">
                                    <label>Daily Standby</label>
                                    <p>
                                        Check this switch to make yourself available for today and your dispatcher will be updated. This switch will be updated every day, 10pm local.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row c-responsive-fixwidth mt-30">
                        <div class="col-md-12">
                            <!-- <h1 class="h1">Wishlist  Employee: {{employee_name}}</h1> -->
                            <h3 class="h3">Drag and drop the jobs to your wishlist or you want to ignore.</h3>
                        </div>
                    </div>
                </div>

                <!-- /Heading Section -->
            </div>
            <!-- /Main Body Content area -->
            <!-- Individual calls section area -->
            <div class="o-ndividualTable">
                <div v-if="searchOpen" class="c-common-space jobs-gridview c-responsive-fixwidth o-overflow-visible">
                    <div class="row">


                        <!-- single grid -->
                        <div class="col-sm-6 col-md-4">
                            <div class="grids c-common-box-shadow c-radius3 c-bg-white">
                                <!-- head -->
                                <div class="head">
                                    <div class="title">
                                        <a href="javascript:void(0)">Scheduled</a>
                                    </div>
                                </div>
                                <!-- /head -->
                                <!-- body -->
                                <div class="body">
                                    <div class="o-schedule-wishlist-scroll scrollbar-style o-wishlist-box1">


                                        <drag :transfer-data="{ jobId: schedule.id,wishId:0 }"  v-for="schedule in scheduled" :key="schedule.id">
                                        <div class="o-skill-box c-common-gradient c-common-box-shadow c-radius3 c-margin-bottom-10 o-schedule-table">
                                            <div class="schedule-box-left">
                                                <div class="skill-details">
                                                    <div class="schedule-details-box">
                                                        <p><a href="javascript: void(0)">{{schedule.title}}</a></p>
                                                        <p><strong>Duration:</strong> {{getGlobalDateFormat(schedule.start) +' - '+ getGlobalDateFormat(schedule.end)}}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </drag>
                                    </div>
                                </div>
                                <!-- /body -->
                            </div>
                        </div>
                        <!-- /single grid -->
                        <!-- single grid -->
                        <div v-if="wishlistLock" class="col-sm-6 col-md-4">
                            <div class="grids c-common-box-shadow c-radius3 c-bg-white o-overflow-visible">
                                <!-- head -->
                                <div class="head o-wishlist-head2">
                                    <div class="o-wishlist-icon">
                                        <img src="static/assets/images/wishlist-icon1.png" />
                                    </div>
                                    <div class="title">
                                        <a href="javascript:void(0)">Add jobs to your wishlist</a>
                                    </div>
                                </div>
                                <!-- /head -->
                                <!-- body -->
                                <div class="body">
                                    <div class="o-schedule-wishlist-scroll scrollbar-style o-wishlist-box2">
                                    <drag :transfer-data="{ jobId: wish.job_id,wishId:wish.id }" v-for = "wish in wishList" :key="wish.id">
                                        <div class="o-skill-box c-common-gradient c-common-box-shadow c-radius3 c-margin-bottom-10 o-schedule-table">
                                            <div class="schedule-box-left">
                                                <div class="skill-details">
                                                    <div class="schedule-details-box">
                                                        <p>{{wish.title}}</p>
                                                        <p><strong>Duration:</strong> {{getGlobalDateFormat(wish.start) +' - '+ getGlobalDateFormat(wish.end)}}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="getPower('wishlistAction')" class="schedule-box-left o-wishlist-right">
                                                <div class="skill-details">
                                                    <div class="schedule-details-box">
                                                        <p class="o-wishlist-delete" @click="deleteWishlist('wishlist',wish.id)"><a class="o-wishlist-delete"><i class="fa fa-trash" aria-hidden="true"></i></a></p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </drag>
                                    </div>

                                </div>
                                <!-- /body -->
                                <!-- bottom -->
                                <drop v-if="getPower('wishlistAction')"  @drop="handleDragover('wishlist',...arguments)" @dragover="highlightWishMethod()" @dragleave="removeHightlight()">
                                    <div v-loading="wishlistLoad" :class="{'o-wishlist-drag-area':true, 'bottom':true ,'highlight':hightlightWish} ">
                                        <div class="o-wislist-drop">
                                            <div class="o-wislist-drop-note">
                                                <i class="fa fa-files-o" aria-hidden="true"></i><br />
                                                Drag and drop here
                                            </div>
                                        </div>
                                    </div>
                                </drop>
                                <!-- /bottom -->
                            </div>
                        </div>
                        <!-- /single grid -->
                        <!-- single grid -->
                        <div v-if="ignorelistLock" class="col-sm-6 col-md-4">
                            <div class="grids c-common-box-shadow c-radius3 c-bg-white o-overflow-visible">
                                <!-- head -->
                                <div class="head o-wishlist-head2">
                                    <div class="o-wishlist-icon">
                                        <img src="static/assets/images/wishlist-icon2.png" />
                                    </div>
                                    <div class="title">
                                        <a href="javascript:void(0)">Jobs you want to ignore</a>
                                    </div>
                                </div>
                                <!-- /head -->
                                <!-- body -->
                                <div class="body">
                                    <div class="o-schedule-wishlist-scroll scrollbar-style o-wishlist-box2">
                                    <drag :transfer-data="{ jobId: ignore.job_id,wishId:ignore.id }" v-for = "ignore in ignoreList" :key="ignore.id">
                                        <div class="o-skill-box c-common-gradient c-common-box-shadow c-radius3 c-margin-bottom-10 o-schedule-table">
                                            <div class="schedule-box-left">
                                                <div class="skill-details">
                                                    <div class="schedule-details-box">
                                                        <p>{{ignore.title}}</p>
                                                        <p><strong>Duration:</strong> {{getGlobalDateFormat(ignore.start) +' - '+ getGlobalDateFormat(ignore.end)}}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="getPower('wishlistAction')" class="schedule-box-left o-wishlist-right">
                                                <div class="skill-details">
                                                    <div class="schedule-details-box">
                                                        <p class="o-wishlist-delete" @click="deleteWishlist('ignorelist',ignore.id)"><a class="o-wishlist-delete"><i class="fa fa-trash" aria-hidden="true"></i></a></p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </drag>
                                    </div>

                                </div>
                                <!-- /body -->
                                <!-- bottom -->
                                <drop v-if="getPower('wishlistAction')" @drop="handleDragover('ignorelist',...arguments)" @dragover="highlightIgnoreMethod()" @dragleave="removeHightlight()">
                                <div v-loading="ignorelistLoad" :class="{'o-wishlist-drag-area' :true, 'bottom':true ,'highlight':hightlightIgnore}">
                                    <div class="o-wislist-drop">
                                        <div class="o-wislist-drop-note">
                                            <i class="fa fa-files-o" aria-hidden="true"></i><br />
                                            Drag and drop here
                                        </div>
                                    </div>
                                </div>
                            </drop>
                                <!-- /bottom -->
                            </div>
                        </div>
                        <!-- /single grid -->
                    </div>

                </div>
                <employeeSearch v-if="!searchOpen" :searchString="search_query" :requestPage="'wish-list'"></employeeSearch>
            </div>
        </div>
        <div v-else>
            <NotAllowed />
        </div>
        <modal name="wish_list_notes" width="50%" height="auto" margin="auto" :scrollable="true" class="modal-dialog modal-sm modal--custom">
            <div tabindex="-1" role="dialog">
                <div role="document">
                    <div class="modal-header text-center p-10">
                        <button @click="closeDisplayWishListNotes()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        <h3 class="modal-title">Notes For Dispatcher</h3>
                    </div>
                    <div class="modal-body o-modal-body">
                        <div class="row px-20">
                            <div class="col-sm-12 o-no-padding o-running-strip p-3">
                                <textarea v-model="wish_list_data.employee_message" data-vv-scope="vacation-add" name="label" class="form-control" rows="4" placeholder="Notes for Dispatcher"></textarea>
                                <button typ="button" class="mt-20 float-right submit-button" @click="moveToWishList(wish_list_data,'wishlist')">Submit</button>
                            </div>
                        </div>
                    </div>						
                        <!-- /.modal-content -->
                </div>
            </div>
		</modal>
    </div>
</template>

<script>
    import { VueEditor } from 'vue2-editor';
    import { mapGetters, mapActions } from 'vuex';
    import service from '../../services.js';
    import {bus} from '../../main';
    import dateTimeConvert from '../../timeConvert&Compare.js';
    import NotAllowed from '@/components/NotAllowed';

    import employeeSearch from '../employees/employeeSearch';

    export default {
        components: {
            VueEditor,
            employeeSearch,
            NotAllowed
        },
        data() {
            return {
                isEmployeeAllowed: true,
                loading:true,
                employee_name:'',
                profileImage:null,
                employeePhone:[],
                'scheduled': [],
                'wishList': [],
                'ignoreList': [],
                'hightlightWish': false,
                'hightlightIgnore': false,
                'wishlistLoad': false,
                'ignorelistLoad': false,
                'wishlistLock':false,
                'ignorelistLock':false,
                'search_query':'',
                userDateFormat: null,
                userTimeFormat: null,
                availability_status: 0,
                wish_list_data: {
                    job_id: '',
                    type: '',
                    employee_message: ''
                },
            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
                getWishListType: 'getWishListType',
            }),

            searchOpen(){
                // console.log(this.search_query.length);
                return (this.search_query.length==0)?true:false;
            },

        },
        methods: {
            changeAvailabilityStatus() {
                console.log(this.availability_status);
                
                service.post('employee/updateMyAvailibility', {
                    'client_id': this.userClientID,
                    'employee_id': atob(this.$route.params.empId),
                    'switch_status': this.availability_status
                }, {
                    'Authorization': this.userToken
                }).
                then((res) => {
                    this.$Progress.finish();
                    console.log(res.data);
                    this.$notify.success({
                        message: 'Updated Successfully',
                        title: 'Success'
                    })
                    this.getEmpDetails();
                }).catch((err) => {
                    this.$Progress.finish();
                    console.log(err);
                    this.$notify.error({
                        message: 'Something went wrong',
                        title: 'Error'
                    })
                });
            },
            getPower(data) {
                //console.log('headernav',typeof dateTimeConvert.checkAccess(data));
                return dateTimeConvert.checkAccess(data);
            },
            editEmployee(){
                // this.$store.dispatch('setEditEmployeesFrom', 'empSchedule');
                this.$router.push({
                    'path': '/editEmployee/'+this.$route.params.empId
                });
            },
            scheduleSmslog() {
                this.$store.dispatch('setNotificationType', 'employeeAction');
                this.$router.push({
                    path: `/notifyLog/`+this.$route.params.empId
                });
            },
            scheduleActionlog() {
                this.$store.dispatch('setActionTypeForLog', 'employeeAction');
                this.$router.push({
                    path: `/actionlog/`+this.$route.params.empId
                });
            },
            schedule(){
                this.$router.push({
                    path: `/schedule/`+ this.$route.params.empId
                });
            },
            getDate(data){
                return moment(data).format('MM/DD/YYYY');
            },
            getGlobalDateFormat(date) {
                return dateTimeConvert.globalDate(date,this.userDateFormat);
            },
            backTo() {
               this.$router.go(-1);                
            },
            viewSchedule(){
                this.$router.push({
                    path: `/schedule/`+this.$route.params.empId
                }); 
            },
            handleDragover(type, data, event) {
                //alert('type');
                if (type == 'wishlist') {
                    this.wishlistLoad = false;
                }
                if (type == 'ignorelist') {
                    this.ignorelistLoad = false;
                }
                if (data.wishId == 0 && type == 'wishlist') {

                    // this.moveToWishList(data,type);
                    this.wish_list_data.job_id = data.jobId;
                    this.wish_list_data.type = type;
                    this.wish_list_data.employee_message = '';
					this.$modal.show('wish_list_notes');
                } else {
                    let body = {
                        'type': type,
                        'employee_id': atob(this.$route.params.empId)
                    }
                    if(data.wishId != 0) {
                        body['wishlist_id'] = data.wishId
                    }
                    service.post('employee/changeWishlistStatus', body, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                        'jobId': data.jobId,
                        // 'employeeId': atob(this.$route.params.empId)
                    }).
                    then((res) => {
                        this.hightlightWish = false;
                        this.hightlightIgnore = false;
                        this.jobsScheduled();
                        this.wishlist();
                        this.ignorelist();
                        this.wishlistLoad = false;
                        this.ignorelistLoad = false;

                    }).catch((err) => {
                        console.log(err);
                    });
                }
            },
            async moveToWishList(data,type) {
                // console.log("Check 123");
                this.wishlistLoad = true;
                await service.post('employee/' + atob(this.$route.params.empId) + '/' + type, {
                        'jobId': data.job_id,
                        'employee_message': data.employee_message
                    }, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                        'jobId': data.job_id,
                        // 'employeeId': atob(this.$route.params.empId)
                    }).
                    then((res) => {
                        this.hightlightWish = false;
                        this.hightlightIgnore = false;
                        this.wish_list_data = {
                            job_id: '',
                            type: '',
                            employee_message: ''
                        };
                        this.closeDisplayWishListNotes()
                        this.jobsScheduled();
                        this.wishlist();
                        this.ignorelist();
                        this.wishlistLoad = false;
                        this.ignorelistLoad = false;
                    }).catch((err) => {
                        console.log(err);
                    });
            },
            highlightWishMethod() {

                this.hightlightWish = true;
            },
            highlightIgnoreMethod() {
                //console.log("ignore");
                this.hightlightIgnore = true;
            },
            removeHightlight() {
                this.hightlightWish = false;
                this.hightlightIgnore = false;
            },
            jobsScheduled() {
                //    this.$Progress.start();
                service.get('job/employeeJobNotInWishlist', {
                    'Authorization': this.userToken,
                    'cs3-context-clientId': this.userClientID,
                    'employeeId': atob(this.$route.params.empId)

                }).
                then((res) => {
                    this.scheduled = res.data.result;
                    //console.log(this.scheduled);
                }).catch((err) => {
                    console.log(err);
                });
            },
            wishlist() {

                service.get('employee/' + atob(this.$route.params.empId) + '/wishlist', {
                    'Authorization': this.userToken,
                    'cs3-context-clientId': this.userClientID,
                    'cs3-context-role': this.userRole,
                    // 'employeeId': atob(this.$route.params.empId)

                }).
                then((res) => {
                    this.wishList = res.data.result;
                    //console.log(atob(this.$route.params.empId));

                }).catch((err) => {
                    console.log(err);
                });
            },
            ignorelist() {
                service.get('employee/' + atob(this.$route.params.empId) + '/ignorelist', {
                    'Authorization': this.userToken,
                    'cs3-context-clientId': this.userClientID,
                    'cs3-context-role': this.userRole,
                    // 'employeeId': atob(this.$route.params.empId)

                }).
                then((res) => {
                    this.ignoreList = res.data.result;
                    //console.log(this.ignoreList);
                }).catch((err) => {
                    console.log(err);
                });
            },
            deleteWishlist(type, wishlist_id) {
                service.del('employee/' + atob(this.$route.params.empId) + '/' + type, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'wishlistId': wishlist_id,
                    // 'employeeId': atob(this.$route.params.empId)
                }).
                then((res) => {

                    this.jobsScheduled();
                    this.wishlist();
                    this.ignorelist();
                }).catch((err) => {
                    console.log(err);
                });
            },
            getClient(){
                service.get('client/' + this.userClientID, {
                    'Authorization': this.userToken
                }).
                then((res) => {
                    this.wishlistLock = (res.data.result.wishlist_lock == 1)?true:false;
                    this.ignorelistLock=(res.data.result.ignorelist_lock == 1)?true:false;    
                }).catch((err) => {
                    console.log(err);
                });
            },
            getEmpDetails() {
                // this.getBaseURL = global[0].IMAGE_URL;
                //this.$Progress.start();
                this.loading=true;
                service.get('employee/' + atob(this.$route.params.empId), {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                })
                .then((res) => {
                    this.loading=false;
                    this.employee_name = res.data.result.employable?res.data.result.employable.first_name+' '+res.data.result.employable.last_name:'';
                    this.profileImage=res.data.result.employable?res.data.result.employable.image:null;
                    this.employeePhone=res.data.result.employable?res.data.result.employable.phones:[];
                    this.userDateFormat=res.data.result.employable?res.data.result.date_format:null;
                    this.userTimeFormat=res.data.result.employable?res.data.result.time_format:null;

                    this.availability_status=this.getEmployeeAvailabilityStatus(res.data.result.employee_availability) 
                    // console.log(res.data.result.date_format,res.data.result.time_format);
                    // console.log(this.userDateFormat,this.userTimeFormat);
                    // console.log(res);
                }).catch((err) => {
                    console.log(err);
                    this.loading=false;
                    if(err.response&&err.response.status&&err.response.status==403) {
                        this.isEmployeeAllowed = false;
                        this.$notify({
                            title: 'Important message',
                            message: "You don't have Access!",
                            type: 'error'
                        });
                        this.$router.push({path: '/schedule/', params: {empId: this.$route.params.empId}});
                    }
                });
            },
            getEmployeeAvailabilityStatus(data) {
                var status = 0;
                var empID = atob(this.$route.params.empId);
                if(data.length) {
                    for(let i=0; i<data.length; i++) {
                        if(data[i].client_id==this.userClientID&&data[i].employee_id == empID) {
                            status = 1;
                            break;
                        }
                    }
                }
                return status;
            },
            async resetEmployeeAvailabilityList() {
                await service.post('employee/flushEmployeeAvailability', {}, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                })
                .then((res) => {
                    console.log(res);
                }).catch(error=>{
                    console.log(error)
                })
            },

            closeDisplayWishListNotes() {
				this.$modal.hide('wish_list_notes');
            }
        },
        created() {
            this.getEmpDetails();
            this.getClient();
            this.jobsScheduled();
            this.wishlist();
            this.ignorelist();
            this.resetEmployeeAvailabilityList();

            bus.$on('onsearchAction', (data) => {
                if(data=='wish-list'){
                    this.search_query='';
                    this.getEmpDetails();
                    this.jobsScheduled();
                    this.wishlist();
                    this.ignorelist();
                }
                // this.getEmpDetails();
            });
        }
    }

</script>
<style scoped>
.px-20 {
    padding: 0 20px;
}
.submit-button {
    margin: 15px 10px 10px 0;
    padding: 10px 20px;
    border: none;
    outline: none;
    background-color: #258325;
    color: #ffffff;
    font-size:13px;
    font-weight: bold;
    border-radius: 5px;
  }
  .p-10 {
    padding: 10px;
  }
.mt-20 {
    margin-top: 20px;
}
.float-right {
    float: right;
}
.mt-30 {
    margin-top: 30px;
}

.switch-para-block{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
}

.switch-para-block .toggle-btn {
    margin-right: 15px; 
}

.switch-para-block .content {
    padding: 0 20px 10px 10px;
}

.switch-para-block .content label {
    padding: 0 20px 5px 0;
    font-weight: 500;
}

.switch-para-block .content p {
    line-height: 1.5;
}
</style>



// WEBPACK FOOTER //
// src/components/schedule/wishlist.vue